import { render, staticRenderFns } from "./InsectConfig.vue?vue&type=template&id=1d347516&scoped=true"
import script from "./InsectConfig.vue?vue&type=script&lang=ts"
export * from "./InsectConfig.vue?vue&type=script&lang=ts"
import style0 from "./InsectConfig.vue?vue&type=style&index=0&id=1d347516&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d347516",
  null
  
)

export default component.exports